<template>
  <!-- 订单列表页面 -->
  <section class="tabWrap">
    <!-- 头部tab -->
    <div class="searchBox">
      <van-search v-model="searchValue" :clearable="true" show-action background="#fff" placeholder="请输入商品名称或订单编号搜索" @search="onSearch">
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
    </div>
    <div class="statusTypeTabBox">
      <div class="table">
        <Tab
          :data="statusTypeTab"
          :active="statusActive"
          @click="clickStatusType"
          :activeStyle="'color:#3088c5;font-size:14px'"
          :style="'color:#333;font-size:14px'"
        />
      </div>
      <div class="orderListPage">
        <!-- 订单列表 -->
        <section class="orderListWrap">
          <van-divider v-if="!cardData.length && !isShowLoad" dashed :style="{ color: '#ddd', borderColor: '#ccc', padding: '0 16px' }"
            >{{ statusActive ? '无此类订单' : '无订单数据' }}
          </van-divider>
          <van-list v-model:loading="isShowLoad" :finished="hasFinished" :finished-text="cardData.length ? '~ 没有更多了~' : ''" @load="init" direction="down">
            <OrderCard :data="cardData" @click="clickCard" @clickBtn="clickBtn" @clickDelete="clickDelete" @refresh="onSearch" @viewUseDealer="viewUseDealer" />
          </van-list>
        </section>
        <!-- 操作确认弹窗 -->
        <van-dialog
          v-model:show="isShowDialog"
          title=""
          :before-close="beforeCloseDialog"
          show-cancel-button
          :confirm-button-text="dialogConfig.confirmButtonText"
          confirm-button-color="#3088c5"
        >
          <div class="dialogContent">
            <div v-if="dialogConfig.isTyreOrder" class="cancelReasonBox">
              <van-radio-group v-model="cancelReasonRes">
                <van-radio :name="index" icon-size="14px" v-for="(item, index) in cancelReason" :key="index">{{ item }}</van-radio>
              </van-radio-group>
            </div>
            <div v-else-if="dialogConfig.isContractOrder" class="contractOrderBox">
              <h4 class="contractTitle">{{ dialogConfig.title }}</h4>
              <p class="contractPay">
                付款金额：<span class="themeRed">￥{{ dialogConfig.payAmount }}</span>
              </p>
              <div class="contractOrderContent">
                <div class="contractOrderItem" v-for="item in dialogConfig.contractOrderList" :key="item.orderNo">
                  <p>订单编号：{{ item.orderNo }}</p>
                  <p class="productsNames">{{ item.productsNames }}</p>
                </div>
              </div>
            </div>
            <div v-else>{{ dialogConfig.content }}</div>
          </div>
        </van-dialog>
      </div>
    </div>
    <div v-show="false">
      <UseDealer ref="useDealerRef" :isShowPhone="true" :param="applyDealerParam"> </UseDealer>
    </div>
    <SubmitOrder ref="showSubmitOrderPopUp" />
  </section>
</template>

<script>
export { default } from '@/util/order/listSetup.js'
</script>

<style lang="scss" scoped>
.orderListPage {
  background-color: #f5f5f5;
  color: #666666;
  font-size: 12px;
  height: calc(100vh - 188px);
  overflow-y: scroll;
  :deep(.van-popup.van-dialog button) {
    background: #fff;
    color: #666;
  }
  :deep(.dialogContent) {
    padding: 38px 10px;
    color: #333;
    font-size: 16px;
    font-weight: 400;
  }
}
.tabWrap {
  position: fixed;
  left: 0;
  top: 80px;
  width: 100%;
  z-index: 1000;
  margin-bottom: 10px;
  background-color: #fff;
  :deep(.van-search) {
    padding: 16px 10px 5px 20px;
  }
  :deep(.van-search__content) {
    border: 1px solid #eee;
    background-color: #fff;
  }
}
.statusTypeTabBox {
  padding: 5px 0 1px;
}
.table {
  padding: 0 10px;
  box-sizing: border-box;
}
.cancelReasonBox {
  padding: 0 30px;
  .van-radio + .van-radio {
    margin-top: 10px;
  }
}
</style>
